<div *ngIf="showSearchBar || showColumnRenderer" class="row margin-standard">
	<div class="col-7">
		<div *ngIf="showSearchBar" class="asset-search">
			<input type="text" class="search-input" placeholder="Search for a fund" [formControl]="searchFormControl" /><icon type="search" class="icon"></icon>
		</div>
	</div>
	<div class="col-10"></div>
	<div class="col-7 text-align-right">
		<!-- <ac-select-columns
			*ngIf="showColumnRenderer"
			[columnsObject]="columnsObject"
			(onColumnsChange)="changeColumns($event)"
			(onColumnsObjectChange)="setColumnObject($event)"
		></ac-select-columns> -->
	</div>
</div>
<div class="table-container">
	<table cdk-table [dataSource]="dataOnPage$" multiTemplateDataRows>
		<ng-container *ngFor="let column of displayedColumns; let index = index">
			<ng-container cdkColumnDef="{{ column }}" [sticky]="stickyColumnIndex.includes(index)">
				<th
					cdk-header-cell
					*cdkHeaderCellDef
					(click)="adjustSort(column)"
					[ngClass]="[
						dataArray[0][column].config.label.attributes.columnAlignment ? dataArray[0][column].config.label.attributes.columnAlignment : '',
						dataArray[0][column].config.label.attributes.className ? dataArray[0][column].config.label.attributes.className : '',
						dataArray[0][column].config.label.attributes.borderClassName ? dataArray[0][column].config.label.attributes.borderClassName : '',
						'text-bold'
					]"
					[class.hidden]="columnsToHideIndex.includes(index)"
					[class.ac-sticky-header]="stickyColumnIndex.includes(index)"
					[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
				>
					<div class="th-inner-wrapper">
						<span>{{ column }}</span>
						<div class="infobubble-sort-wrapper">
							<!-- Info bubble  -->
							<icon
								*ngIf="showInfoBubble && infoBubbleMappings[column] && dataArray[0][column].config.id !== 'iSharesIdeas'"
								type="info-circle"
								class="info-circle text-14 color-primary"
								[tooltip]="infoBubble"
								[analytic-data]="{ linkName: 'tooltip_' + dataArray[0][column].config.label }"
							></icon>
							<ng-template #infoBubble> <section [innerHTML]="infoBubbleMappings[column]"></section> </ng-template>

							<!-- Info bubble for iShares Ideas column -->
							<icon
								*ngIf="showInfoBubble && infoBubbleMappings[column] && dataArray[0][column].config.id === 'iSharesIdeas'"
								type="info-circle"
								class="info-circle pointer"
								(click)="toggleInfoDialog(dataArray[0][column].config.label.key, infoBubbleMappings[column])"
							>
							</icon>

							<!-- Sorting -->
							<ng-container *ngIf="dataArray[0][column].config.id !== 'iSharesIdeas' && isSortable">
								<icon type="sort" *ngIf="sortKey$.value !== column" class="sort-icon"></icon>
								<icon type="sort-asc" *ngIf="sortKey$.value === column && sortDirection$.value === 1" class="sort-icon"></icon>
								<icon type="sort-desc" *ngIf="sortKey$.value === column && sortDirection$.value === -1" class="sort-icon"></icon>
							</ng-container>
						</div>
					</div>
				</th>
				<td
					cdk-cell
					*cdkCellDef="let element"
					[ngClass]="[
						element[column].config.label.attributes.className ? element[column].config.label.attributes.className : '',
						element[column].config.label.attributes.borderClassName ? element[column].config.label.attributes.borderClassName : '',
						element[column].config.label.attributes.columnAlignment ? element[column].config.label.attributes.columnAlignment : 'text-align-center'
					]"
					[style.background-color]="element[column] && element[column].attribute ? element[column].attribute.backgroundColor : null"
					[class.hidden]="columnsToHideIndex.includes(index)"
					[class.color-cell]="element[column] && element[column].attribute && element[column].attribute.backgroundColor"
					[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
				>
					<ac-table-cell [data]="element[column]"></ac-table-cell>
				</td>
			</ng-container>
		</ng-container>

		<!-- this expand row feature is not fully implemented, will do it later to take in child component -->
		<ng-container cdkColumnDef="expandedDetail">
			<td cdk-cell *cdkCellDef="let element" [attr.colspan]="displayedColumns.length">
				<div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"><div class="element-diagram">test</div></div>
			</td>
		</ng-container>

		<!-- Header and Row Declarations -->
		<tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
		<tr cdk-row *cdkRowDef="let element; columns: displayedColumns" class="element-row" [class.expanded-row]="expandedElement === element" (click)="expandRow(element)"></tr>
		<tr cdk-row *cdkRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
	</table>
</div>
<div class="row" *ngIf="showPagination">
	<div class="col-24">
		<ac-pagination
			[collectionSize]="tableDataSource$.value.length"
			[pageSize]="pageSize$.value"
			[page]="currentPage$.value"
			(pageChange)="currentPage$.next($event)"
			(pageSizeChange)="pageSize$.next($event)"
		>
		</ac-pagination>
	</div>
</div>

<!-- Modal to show info bubble info for iShares Ideas column -->
<bfa-modal width="750px" [enableBackdrop]="true" [enableClose]="true" [isVisible]="showiSharesIdeasInfoBubbleModal" (isVisibleChange)="showiSharesIdeasInfoBubbleModal = false">
	<section class="modal-message-container text-13" [innerHTML]="iSharesIdeasInfoBubbleText"></section>
</bfa-modal>
